import * as angular from "angular";

angular
  .module('app.permission')
  .constant('permissionsConsts', {
    version: {
      general: 'General',
      beta: 'Beta'
    }
  })
